const buildSiloSubmitModel = (model) => {
    const capacity = `${model.capacity ?? ''}`.trim();
    return { ...model, capacity: capacity === '' ? null : parseFloat(capacity) };
};

export default buildSiloSubmitModel;
